import React from "react";
import { Alert as AlertMaterial } from "@mui/material";

const Alert = ({ text, variant, severity, backgroundColor, color, floating = false }) => {
    return  <div style={floating ? { 
                position: "fixed",
                top: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1000,
                width: "fit-content",
                minWidth: "250px",
                maxWidth: "80vw",
            } : {}}>
                <AlertMaterial 
                    variant={variant}
                    severity={severity}
                    sx={{
                        borderRadius: 2,
                        fontFamily: "Roboto, sans-serif",
                        backgroundColor: {backgroundColor},
                        color: {color}
                    }}
                >
                        {text}
                </AlertMaterial>
            </div>
  };
  
  export default Alert;